import { useSearchResults } from '#src/app/pages/search/shared/searchState';

type Result = ModelHookResult<{
	isLoading: boolean;
}>;

export function useMobileFilters(): Result {
	const results = useSearchResults();

	return {
		data: {
			isLoading: results.isInitialLoad,
		},
	};
}
